import { Component, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IApiSageInvoiceAgingReminder, IApiSageInvoiceAgingReminderConnection, IApiSageInvoiceAgingReminderFilter, IApiSageInvoiceAgingReminderFilterType } from 'src/app/shared/modules/graphql/types/types';
import { SageInvoiceAgingReminderService } from 'src/app/shared/services';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';

export interface ISageInvoiceAgingReminderSidebarData {
    sageInvoiceId: string;
    invoiceNumber: string;
}

@Component({
    selector: 'app-bookkeeping-sage-invoice-sidebar',
    templateUrl: './sage-invoice-aging-reminder-sidebar.component.html',
    styleUrls: ['./sage-invoice-aging-reminder-sidebar.component.scss']
})
export class SageInvoiceAgingReminderSidebarComponent extends DialogContentBase implements OnInit {
    public data: ISageInvoiceAgingReminderSidebarData;
    public reminders: IApiSageInvoiceAgingReminder[] = [];

    constructor(
        public dialog: DialogRef,
        private sageInvoiceAgingReminderService: SageInvoiceAgingReminderService,
        private loader: LoaderService
    ) {
        super(dialog);
    }

    ngOnInit() {
        this.loadReminders();
    }

    private loadReminders() {
        const filters: IApiSageInvoiceAgingReminderFilter[] = [
            {
                type: IApiSageInvoiceAgingReminderFilterType.SageInvoiceId,
                value: this.data.sageInvoiceId
            }
        ];

        this.loader.show$(this.sageInvoiceAgingReminderService.sageInvoiceAgingReminders(filters, { limit: -1 })).subscribe((res: IApiSageInvoiceAgingReminderConnection) => {
            this.reminders = res?.edges?.map(edge => edge.node) || [];
            this.reminders = this.reminders?.map(r =>  ({
              ...r,
              emails: r?.emails?.replace(/,\s*/g, ' ')
            }));
        });
    }

    public close() {
        this.dialog.close();
    }
}
